import api from './api';

class DashboardService {
  getData(dataForm) {
    return api.post('/merchant', dataForm);
  }

  getDataDashboardAllTime(dataForm) {
    return api.post('/merchant/data-dashboard-all-time', dataForm);
  }

  config(dataForm) {
    return api.post('/merchant/dashboard-config', dataForm);
  }

  reloadChart(dataForm) {
    return api.post('/merchant/reload-chart', dataForm);
  }

  searchMember(dataForm) {
    return api.post('/merchant/dashboard/search-member', dataForm);
  }

  getListLinks(dataForm) {
    return api.post('/merchant/dashboard/list-link', dataForm);
  }

  detailTransaction(dataForm) {
    return api.post('/merchant/dashboard/detail-transaction', dataForm);
  }

  eodSummary(dataForm) {
    return api.post('/merchant/dashboard/eod-summary', dataForm);
  }
}

export default new DashboardService();